import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownRightCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.657 2.343A8 8 0 1 0 2.343 13.657A8 8 0 0 0 13.657 2.343M10.75 3.68l-7.071 7.07h7.071z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownRightCircle
